import { FormBase } from 'core/components';

export default class ExitScanModeForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'pallet',
					label: 'FULFILLMENTORDER.EXITSCANMODE.PALLET',
				},
				{
					name: 'warehouse',
					label: 'FULFILLMENTORDER.EXITSCANMODE.WAREHOUSE'
				}
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/ExitScanModeForm.js